import { Text } from '@chakra-ui/react';
import { InputNumber, Slider } from 'antd';
import cn from 'classnames/bind';
import React, { useEffect, useState } from 'react';

import { useMileageFilter } from '@/hooks/filters/mileage-filter.hook';
import { useFiltersQuery } from '@/hooks/used-cars/filters-query.hook';
import { numberWithSpacesToString } from '@/services/string-format.service';

import { PriceFormat } from '../../../../price-format/price-format';
import { InputsSeparator } from '../../../price-finance/components/inputs-separator/inputs-separator';
import { SectionName } from '../../../price-finance/components/section-name/section-name';

import styles from './mileage-filter.module.scss';

const cx = cn.bind(styles);

export const MileageFilter: React.FC<{
  mileageFilterDefault: {
    min: number;
    max: number;
  };
  showInCarFinder?: boolean;
}> = ({ mileageFilterDefault, showInCarFinder }) => {
  const [isFirstRender, setIsFirstRender] = useState<boolean>(true);
  const { mileageFilter, setMileageFilter, setSelectedMileageFilter } =
    useMileageFilter();
  const { isCleared } = useFiltersQuery();

  const marks = {
    [mileageFilterDefault.min]: {
      label: (
        <Text className={styles.sliderFormatText}>
          <PriceFormat value={mileageFilterDefault.min} />
        </Text>
      ),
    },
    [mileageFilterDefault.max]: {
      label: (
        <Text className={styles.sliderFormatText}>
          <PriceFormat value={mileageFilterDefault.max} />
        </Text>
      ),
    },
  };

  useEffect(() => {
    if (isFirstRender) {
      setIsFirstRender(true);

      return;
    }

    setMileageFilter({
      min: mileageFilterDefault.min,
      max: mileageFilterDefault.max,
    });
  }, [isCleared]);

  return (
    <div
      className={cx(styles.mileageWrapper, {
        carFinderWrapper: showInCarFinder,
      })}
    >
      <div className={styles.sectionWrapper}>
        <SectionName>Mileage</SectionName>
        <div
          className={cx(styles.rangesWrapper, {
            rangesCarFinderWrapper: showInCarFinder,
          })}
        >
          <InputNumber
            formatter={(value) =>
              numberWithSpacesToString(Number(value), ' ') || ''
            }
            className="rangeInput"
            value={mileageFilter.min || mileageFilterDefault.min}
            step={5000}
            onChange={(val) => {
              const { min, max } = mileageFilterDefault;

              if (!val || val < min || val > max || val < mileageFilter.min) {
                return;
              }

              setMileageFilter((prevState) => ({
                ...prevState,
                min: val,
              }));

              setSelectedMileageFilter({ ...mileageFilter, min: val });
            }}
          />
          <InputsSeparator />
          <InputNumber
            formatter={(value) =>
              numberWithSpacesToString(Number(value), ' ') || ''
            }
            className="rangeInput"
            value={mileageFilter.max || mileageFilterDefault.max}
            step={5000}
            onChange={(val) => {
              const { min, max } = mileageFilterDefault;

              if (!val || val < min || val > max || val < mileageFilter.min) {
                return;
              }

              setMileageFilter((prevState) => ({
                ...prevState,
                max: val,
              }));

              setSelectedMileageFilter({ ...mileageFilter, max: val });
            }}
          />
        </div>
      </div>
      <Slider
        className={styles.sliderRange}
        range
        marks={marks}
        step={5000}
        max={mileageFilterDefault.max}
        min={mileageFilterDefault.min}
        value={[
          mileageFilter.min || mileageFilterDefault.min,
          mileageFilter.max || mileageFilterDefault.max,
        ]}
        tipFormatter={null}
        onChange={([min, max]) => {
          setMileageFilter({
            min: min ?? mileageFilterDefault.min,
            max: max ?? mileageFilterDefault.max,
          });
          setSelectedMileageFilter({
            min: min ?? mileageFilterDefault.min,
            max: max ?? mileageFilterDefault.max,
          });
        }}
      />
    </div>
  );
};
